(function () {
  function init(root) {
    if (root.dataset.hatReady) return;
    root.dataset.hatReady = 'true';
    var select = root.querySelector('[data-hat-variant]');
    var quantity = root.querySelector('[data-hat-quantity]');
    var photo = root.querySelector('[data-hat-image]');
    function setPhoto(src, alt) {
      if (!photo || !src) return;
      photo.src = src;
      photo.alt = alt || '';
    }
    function update() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var available = option.dataset.available === 'true';
      root.querySelector('[data-hat-price]').textContent = option.dataset.price;
      var add = root.querySelector('[data-hat-add]');
      add.disabled = !available;
      add.textContent = available ? 'Add to cart' : 'Sold out';
      root.querySelector('[data-hat-status]').textContent = available ? 'Available' : 'This design is sold out.';
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      setPhoto(option.dataset.image, option.dataset.alt);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    }
    select.addEventListener('change', update);
    root.querySelectorAll('[data-hat-thumbnail]').forEach(function (button) {
      button.addEventListener('click', function () { setPhoto(button.dataset.image, button.dataset.alt); });
    });
  }
  document.querySelectorAll('[data-hat-product]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-hat-product]').forEach(init);
  });
})();
